import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

/**
 * Guard for the website entry point (`/` and `/documents`).
 *
 *  - Visitors that are NOT logged in are sent to the login page
 *    (/auth/login). Without this check the documents page was shown to
 *    anonymous users and immediately fired authenticated API calls, which
 *    failed with "Missing request header 'Authorization'...".
 *  - Logged in ADMIN users are redirected to /admin/tickets instead of
 *    landing on the client website documents view.
 *  - Logged in CLIENT / EMPLOYEE users keep the documents view.
 */
export const roleHomeGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }

  if (authService.isAdmin()) {
    return router.createUrlTree(['/admin/tickets']);
  }

  return true;
};
